import CheckboxList, {
  CheckboxDataGroup,
} from "components/components/CheckboxList/CheckboxList";
import { ListClickEvent } from "hooks/useCheckboxList";
import React from "react";

export enum CheckboxState {
  UNCHECKED,
  CHECKED,
  INDETERMINATE,
}

export enum ChevronState {
  CLOSED,
  OPEN,
}

export interface CheckboxDataState extends CheckboxDataGroup {
  checkboxState: CheckboxState;
  chevronState: ChevronState;
}

type CheckboxListContainerProps = {
  listId?: string;
  checkboxDataStates: CheckboxDataState[];
  registerClickForListItem: React.Dispatch<ListClickEvent>;
};

const CheckboxListContainer: React.FC<CheckboxListContainerProps> = ({
  listId,
  checkboxDataStates,
  registerClickForListItem,
}) => (
  <CheckboxList
    listId={listId}
    onClick={registerClickForListItem}
    checkboxDataState={checkboxDataStates}
  />
);

export default CheckboxListContainer;
